import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import {
  AttendanceMessageDatasetType,
  AttendanceMessageType,
  SectionUserActivityType,
} from "../../shared/types/attendance";
import type { GroupPreviewSnapshotMessageType } from "../../shared/types/page-group-preview";

import { createReplaceAllReducer } from "store/utils";

export type PageGroupPreviewsState = Record<string, Record<string, string>>;

type InterimState = {
  sectionUserActivities: Record<string, SectionUserActivityType>;
  pageGroupPreviews: PageGroupPreviewsState;
};

const defaultState: InterimState = {
  sectionUserActivities: {},
  pageGroupPreviews: {},
};

const initialState = () => defaultState;

const updateUserActivityInstance = (state: InterimState, activity: SectionUserActivityType) => {
  state.sectionUserActivities[activity.userId] = activity;
};

export const InterimStore = createSlice({
  name: "interim",
  initialState,
  reducers: {
    updateActivityData: (state, action: PayloadAction<SectionUserActivityType[]>) => {
      action.payload.forEach((activity) => {
        updateUserActivityInstance(state, activity);
      });
    },
    updateUserActivity: (state, action: PayloadAction<AttendanceMessageType>) => {
      const { removed, ...activity } = action.payload;

      if (activity.datasetType !== AttendanceMessageDatasetType.SECTION_USER_ACTIVITY) return;

      if (removed === "1") {
        delete state.sectionUserActivities[activity.userId];
      } else {
        updateUserActivityInstance(state, activity);
      }
    },
    setPageGroupPreviewSnapshot: (
      state,
      action: PayloadAction<GroupPreviewSnapshotMessageType>,
    ) => {
      state.pageGroupPreviews[action.payload.pageId] = action.payload.preview;
    },
    clearPageGroupPreview: (state, action: PayloadAction<string>) => {
      delete state.pageGroupPreviews[action.payload];
    },
  },
  extraReducers: createReplaceAllReducer<InterimState>("interim", initialState),
});

export const interimStateActions = InterimStore.actions;
